<div
	[ngClass]="collapsed ? 'keyboard-arrowdown-mask-img' : 'keyboard-arrowup-mask-img'"
	class="icon-size enabled chevron mask-settings bg-dark cursor-pointer accordion-icon"
	(click)="toggle()"></div>
